import { baseClient } from '@store/index';
import { MessageProfileNumber, TelnyxMessagingProfile, UpdateMessageWebhookParams } from '.';
import { QueryFunctionContext } from '@tanstack/react-query';

export const getMessagingProfiles = async (): Promise<TelnyxMessagingProfile[]> => {
  const url = '/telnyx/messaging_profiles';
  const response = await baseClient.get<TelnyxMessagingProfile[]>(url);
  return response.data || [];
};

export const getNumberByMessagingProfile = async ({
  queryKey,
}: QueryFunctionContext<[string, string | undefined]>): Promise<MessageProfileNumber[]> => {
  const [, profileId] = queryKey;

  const url = `/telnyx/phone_numbers/messaging_profile/${profileId}`;
  const response = await baseClient.get<MessageProfileNumber[]>(url);
  const phoneNumbers = response.data;
  return phoneNumbers;
};

export const updateMessagingProfileWebhook = async ({
  profileId,
  service_id,
  workflow_id,
  v1_secret,
}: UpdateMessageWebhookParams): Promise<TelnyxMessagingProfile> => {
  const url = `/telnyx/messaging_profiles/${profileId}/webhook`;
  const response = await baseClient.patch<TelnyxMessagingProfile>(url, { service_id, workflow_id, v1_secret });
  return response.data;
};
